const validationResultTypes = {
  Good: 0,
  Error: 1,
  Warning: 2,
};

export default validationResultTypes;
